import React from "react";

import ConstructionIcon from "@mui/icons-material/Construction";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import WorkIcon from "@mui/icons-material/Work";

import "./Web.css";

function Web() {
  return (
    <div className="web">
      <div className="web-option">
        <a href="#about">
          <span className="option-iocn">&#128113; About Me </span>
        </a>
      </div>
      <div className="web-option">
        <a href="#skills">
          {" "}
          <span className="option-iocn">&#128187; Skills </span>
        </a>
      </div>
      <div className="web-option">
        <a href="#project">
          <ConstructionIcon className="option-icon" />
          Project
        </a>
      </div>

      <div className="web-option">
        <a href="#work">
          <span className="option-iocn">&#128188; Work </span>
        </a>
      </div>
      <div className="web-option">
        <a href="#contact">
          <ContactMailIcon className="option-icon" />
          Contact
        </a>
      </div>
    </div>
  );
}

export default Web;
